import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import { useMemo } from 'modules/core/hooks/useMemo'

import ManualIncidencesCollection from 'modules/bookkeepers/store/collections/manualIncidences'
import type ManualIncidenceForm from 'modules/payroll_bundle/pages/IncidencesPage/utils/manualIncidenceForm'

const useCreateManualIncidence = (form: ManualIncidenceForm, handleClose: () => void) => {
  const manualIncidences = useMemo(() => new ManualIncidencesCollection(), [])

  const { running: loading, performAction: create } = useAsyncAction(
    async () => {
      const manualIncidence = await form.create(manualIncidences)

      if (manualIncidence) {
        handleClose()
      }
    },
    { successFlash: true }
  )

  return {
    loading,
    create,
  }
}

export default useCreateManualIncidence
